import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../components/table/TableOps.tsx';
import TableComponent from '../../components/table/TableOps';
import Rol from './Rol.js';

class Roles extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'usuario-rol/filter', deleteUrl: 'usuario-rol/delete', deleteField: 'rol_nombre', modUrl: '/RolAccess' },
      TableOp.Table('Roles de Usuario', [
        { label: 'Rol', id: 'rol_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [] },
        { id: 'delete', icon: 'delete', access: [] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          <Rol  onSave={() => { this.table() }}></Rol>
          <this.TableRender  />
        </div>
      </div>
    )
  }
}

export default withRouter(Roles)